module.exports = __webpack_public_path__ + "img/12.f92251b6.png";